module.exports = __webpack_public_path__ + "static/media/apple-touch-icon-144-precomposed.d2413ec6.png";